
import { Component, Vue } from 'vue-property-decorator';
import Layout from '@/layouts/Default.vue';
import ListBlock from '@/views/CRUD/ListTab.vue';

import CancellationReasonsModule from '@/store/cancellationReasons';
import DirectoriesModule from '@/store/directories';

@Component({
    components: {
        Layout,
        ListBlock,
    },
})
export default class CancellationReasonsPage extends Vue {
    repository = CancellationReasonsModule;

    get tabsNav() {
        return DirectoriesModule.tabsNav;
    }

    get currentTab() {
        return DirectoriesModule.allTabs.cancellationReasons.id;
    }

    get filterSettings() {
        return this.repository.filter.filterSettings;
    }

    toAdd() {
        this.$router.push({ name: 'cancellationReasons_create' });
    }

    async updateList() {
        await this.repository.filter.updateFilter();
        await this.repository.updatePage('1');
    }

    async resetFilters() {
        await this.repository.clearSort();
        await this.repository.filter.resetFilter();
        await this.repository.updatePage('1');
    }
}
